import React from 'react';
import { WizardContent } from '../../components/WizardContent';
import { IChooseUploadMethodStep } from './interfaces';
import { Stack } from '@mui/material';
import { Button } from '../../components/Button';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import InsertPhotoIcon from '@mui/icons-material/InsertPhoto';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import { useTranslation } from 'react-i18next';

export const ChooseUploadMethodStep: React.FC<IChooseUploadMethodStep> = ({
  onSelect,
}): JSX.Element => {
  const { t } = useTranslation();

  return (
    <WizardContent
      text={t('competitions:portal.dialogs.submitScore.uploadMethod.description')}
    >
      <Stack direction="row" justifyContent="center" gap="10px" flexWrap="wrap">
        <Button
          label={t('competitions:portal.dialogs.submitScore.uploadMethod.camera')}
          icon={CameraAltIcon}
          onClick={() => onSelect('photo')}
          disabled
        />
        <Button
          label={t('competitions:portal.dialogs.submitScore.uploadMethod.image')}
          icon={InsertPhotoIcon}
          onClick={() => onSelect('image')}
        />
        <Button
          label={t('competitions:portal.dialogs.submitScore.uploadMethod.qr')}
          icon={QrCode2Icon}
          onClick={() => onSelect('qr')}
          disabled
        />
      </Stack>
    </WizardContent>
  );
};
